module.exports = __webpack_public_path__ + "img/img16.3d5aa91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img16.png
// module id = 192
// module chunks = 0